import { useEffect, useState } from 'react';

type ScrollData = {
  onScroll: (node: any) => void;
  showStart: boolean;
  showEnd: boolean;
};

export const useScrollWithShadow = (node: any, dependencies: string[] = [], width?: number): ScrollData => {
  const [showStart, setShowStart] = useState<boolean>(false);
  const [showEnd, setShowEnd] = useState<boolean>(false);

  const onScroll = (node: any): void => {
    const { scrollLeft = 0 } = node || {};
    // const effectiveWidth = width || node?.scrollWidth || 0;

    setShowStart(scrollLeft > 0);
    setShowEnd(scrollLeft === 0);
  };

  // Stable key so the useEffect deps array below stays constant-size (React requires it); contents still re-run it.
  const _dependenciesKey = JSON.stringify(dependencies);

  useEffect(() => {
    if (node) {
      onScroll(node);
      node.addEventListener('scroll', () => onScroll(node));
    }

    // Clean up event listener on unmount
    return () => {
      if (node) node.removeEventListener('scroll', () => onScroll(node));
    };
  }, [node, width, _dependenciesKey]);

  return { onScroll, showStart, showEnd };
};
